const apiErrorMsg = (status, data) => {
    let errors;
    if (Array.isArray(data) && data.length && typeof(data[0]) === 'string') {
        errors = data;
    } else if (Array.isArray(data) && data.length && typeof(data[0] === 'object') && Array.isArray(data[0].errors)) {
        errors = data[0].errors;
    } else if (data && Array.isArray(data.errors)) {
        errors = data.errors;
    } else {
        errors = data;
    }

    if (typeof(errors) === 'object' && !Array.isArray(errors)) {
        // Example:
        // DELETE /api/v2/release/amendContract => {"":["A non-empty request body is required."]}
        // Counter-example:
        // DELETE /api/v2/release/amendContract => ["Unable to delete - amendment date has passed.  (101)"]
        const formattedErrors = [];
        for (const key in errors) {
            if (key === '') {
                formattedErrors.push(errors[key])
            } else {
                formattedErrors.push(`${key}: ${errors[key]}`)
            }
        }

        errors = formattedErrors;
    }

    const statusMsg = status ? `Status: ${status}. ` : '';
    let errorMsg = '';
    if (errors) {
        if (Array.isArray(errors) && errors.length > 0) {
            errorMsg = errors.join('. ');
        } else {
            errorMsg = errors;
        }
    }
    return `${statusMsg}${errorMsg}`;
};

export default apiErrorMsg;